export default __webpack_public_path__ + "static/media/1524.242c5868.png";